var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.notAcceptingOffers || _vm.alreadyApplied)?_c(_setup.BCXMarkdown,{staticClass:"bc-project-action-apply-error",attrs:{"tag":"div","text":_setup.errorText}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }